import Logger from "../../utils/logger";
import { isNull } from "lodash";
import { GENERIC_ERROR } from "./constants";

class NetworkError {
  constructor(
    summary,
    errors,
    statusCode,
    message,
    fieldName = null,
    errorCode = null
  ) {
    this.summary = summary;
    this.errors = errors;
    this.statusCode = statusCode;
    this.message = message;
    this.fieldName = fieldName;
    this.errorCode = errorCode;
  }
}

const getErrorMessages = (resp) => {
  const code =
    resp.data && resp.data.errorCode ? resp.data.errorCode : resp.status;
  const errors = resp.data.errorCode.split(",");

  const message = errors.map((code) => {
    return GENERIC_ERROR;
  });

  return {
    message,
    errorCode: code,
  };
};
/**
 * Parses network errors (apisauce network stack) or API errors (from our
 * backend) into display-friendly error code / error message pairs.
 */
const parseNetworkError = (response, fieldName) => {
  const DEFAULT_ERROR_MESSAGE = "Something went wrong";

  try {
    if (isNull(response) || response.ok) {
      return null;
    } else if (response.problem === "NETWORK_ERROR") {
      // Error connecting to the network
      return new NetworkError("Network connection failed");
    } else if (
      response.problem === "CLIENT_ERROR" ||
      response.problem === "SERVER_ERROR"
    ) {
      const { originalError } = response;
      const { message, errorCode } = getErrorMessages(response);

      return new NetworkError(
        null,
        originalError.response.statusText,
        originalError.response.status,
        message,
        fieldName,
        errorCode
      );
    }
  } catch (e) {
    Logger.e("Error parsing network error", e);
  }

  return new NetworkError(DEFAULT_ERROR_MESSAGE);
};

export const processResponse = (
  response,
  onSuccess,
  onError,
  fieldName = null
) => {
  if (response.ok) {
    return onSuccess(response.data);
  } else {
    return onError(parseNetworkError(response, fieldName));
  }
};

export const processV2Response = (response, onSuccess, onError) => {
  if (response.status === 200 && response.data.status === "success") {
    return onSuccess(response.data);
  } else {
    const errorMessage = response.data
      ? response.data.message
      : "Something went wrong";
    return onError(errorMessage);
  }
};

export const processError = (error, onFailure) => {
  return onFailure(error);
};

export const processShopifyResponse = (response, onSuccess) => {
  if (response) {
    return onSuccess(response);
  }
};

// TODO: decide how to handle these errors
export const processShopifyErrorResponse = (error, onFailure) => {
  return onFailure(error);
};
